import { connect } from 'react-redux';
import { compose } from 'recompose';

import DatePicker from '../../datePicker/DatePicker';
import { getSelectTimeEntryDate } from '../selectors';
import { setSelectedTimeEntryDateThunk } from '../actions';

const mapStateToProps = (state) => {
  return {
    currentDate: getSelectTimeEntryDate(state),
    showTime: false,
    maxDate: new Date(),
  };
};

const mapDispatchToProps = {
  setDateAction: setSelectedTimeEntryDateThunk,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(withRedux);

export default enhance(DatePicker);
